import { useRef } from 'react';

import { useRecoilValue } from 'recoil';

import { drawerState, useCloseDrawer, useShowDrawer } from '../state/drawer';

const useDrawer = () => {
  const modalChange = useRef(false);
  const { isOpen, drawer } = useRecoilValue(drawerState);
  const { execute: showDrawer } = useShowDrawer();
  const { execute: closeDrawer } = useCloseDrawer();

  return {
    showDrawer,
    closeDrawer,
    isOpen,
    drawer,
    modalChange,
  };
};

export default useDrawer;
